"use client";

import { useSpineSlice } from "@/components/site/motion/useSpineSlice";
import {
  StoryFactValues,
  useStoryFactsActive,
} from "@/components/sections/story/StoryFacts";
import { StoryWorldMap } from "@/components/sections/story/StoryWorldMap";
import { useContent } from "@/components/site/ContentProvider";

/** Mobile-only facts (desktop stats live in SideRight `.side-story`). */
export function Story() {
  useSpineSlice((m) => m.spine!.buildStory());
  const site = useContent();
  const active = useStoryFactsActive(0);

  return (
    <div className="landing_content about_content f f-c a-c j-c" id="about">
      <div className="about_head">
        <h1 className="f f-c desktop">
          {site.about.headline.map((line) => (
            <span key={line}>{line}</span>
          ))}
        </h1>
        <h1 className="f f-c mobile">
          {site.about.headline.map((line) => (
            <span key={`m-${line}`}>{line}</span>
          ))}
        </h1>
      </div>
      <div className="about_head about_head_map f f-c">
        <StoryWorldMap />
        <div className="about_mobile_meta mobile f f-c a-c">
          <span className="uppercase mobile _ele">{site.about.body}</span>
          <div className="facts_set f f-c">
            <StoryFactValues active={active} />
          </div>
        </div>
      </div>
    </div>
  );
}
